
import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../Context/AuthContext.jsx";
import axios from "axios";

const Myteam = ({ activeTab, toggletab, setToggletab }) => {
  const { token, user } = useAuth();
  const [teamdetail, setTeamdetail] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");
  const [teamfirstname, setTeamfirstname] = useState("");
  const [teamlastname, setTeamlastname] = useState("");
  const [teamemail, setTeamemail] = useState("");
  const [teamtype, setTeamtype] = useState("");
  const [error, setError] = useState("");
  const [source, setSource] = useState("");
  const [campaign, setCampaign] = useState("");
  const [medium, setMedium] = useState("");
  const [copiedEmail, setCopiedEmail] = useState("");

  const allTeamInfo = useCallback(async (emailQuery) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/team-details`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { email: emailQuery },
        }
      );

      if (resp.status === 200) {
        const filteredTeamDetails = resp.data.filter(
          (item) => item.email !== user.email
        );
        setTeamdetail(filteredTeamDetails.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  }, [token, user.email]);

  useEffect(() => {
    if (activeTab === 7) {
      allTeamInfo(searchEmail);
    }
  }, [allTeamInfo, searchEmail, activeTab]);

  const handleSearchChange = (event) => {
    setSearchEmail(event.target.value.toLowerCase());
  };

  const handleCopyEmail = (email) => {
    if (!email) return;
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setTimeout(() => setCopiedEmail(""), 2000);
  };

  const addNewmember = async (event) => {
    event.preventDefault();
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/add-team`,
        {
          first_name: teamfirstname + " " + teamlastname,
          email: teamemail,
          user_type: teamtype,
          source: [source],
          campaign: [campaign],
          medium: [medium]
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (resp.status === 201) {
        allTeamInfo(searchEmail);
        setToggletab(false);
        resetForm();
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 400) {
        setError("Email already exists");
        setTimeout(() => setError(""), 2000);
      }
    }
  };

  const changeStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === "active" ? "deactive" : "active";
      const resp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/deactivate`,
        { status: newStatus, id: id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (resp.status === 200) {
        allTeamInfo(searchEmail);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetForm = () => {
    setTeamfirstname("");
    setTeamlastname("");
    setTeamemail("");
    setTeamtype("");
    setSource("");
    setCampaign("");
    setMedium("");
  };

  const closetab = () => {
    setToggletab(false);
    resetForm();
  };

  if (activeTab !== 7) return null;

  return (
    <div className="animate-fadeIn">
      {!toggletab ? (
        <div className="space-y-6">
          {/* Header & Search Bar */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="p-4 bg-gray-50/50 border-b border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="flex items-center gap-2">
                <div className="bg-[#004f6b] p-1.5 rounded-lg text-white">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-800 text-lg">My Team Members</h3>
              </div>

              <div className="flex items-center gap-4 w-full md:w-auto">
                <div className="relative flex-1 md:w-80">
                  <input
                    type="search"
                    placeholder="Search by email..."
                    className="w-full pl-9 pr-3 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={searchEmail}
                    onChange={handleSearchChange}
                  />
                  <svg className="w-4 h-4 text-gray-400 absolute left-3 top-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <button
                  onClick={() => setToggletab(true)}
                  className="px-6 py-2 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-lg font-semibold text-sm transition-all shadow-md shadow-[#004f6b]/20 flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add Member
                </button>
              </div>
            </div>

            <div className="h-full">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-50/80 border-b border-gray-200">
                    <th className="px-6 py-4 text-xs font-medium text-gray-600 text-center w-20">Sr. No</th>
                    <th className="px-6 py-4 text-xs font-medium text-gray-600">Team Member</th>
                    <th className="px-6 py-4 text-xs font-medium text-gray-600">Account & Role</th>
                    <th className="px-6 py-4 text-xs font-medium text-gray-600">Added On</th>
                    <th className="px-6 py-4 text-xs font-medium text-gray-600">Campaign/Medium/Source</th>
                    <th className="px-6 py-4 text-xs font-medium text-gray-600">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {teamdetail.length > 0 ? (
                    teamdetail.map((item, index) => (
                      <tr key={item.id} className="hover:bg-gray-50/50 transition-colors group">
                        <td className="px-6 py-4 text-sm text-gray-400 font-mono text-center">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-3">
                            <div className="h-10 w-10 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-[#004f6b] font-bold group-hover:scale-110 transition-transform">
                              {item.first_name?.charAt(0) || 'U'}
                            </div>
                            <div className="flex flex-col">
                              <span className="text-sm font-semibold text-gray-900 group-hover:text-[#004f6b] transition-colors">
                                {item.first_name} {item.last_name}
                              </span>
                              <div className="flex items-center gap-2">
                                <span
                                  className="text-xs text-gray-500 hover:text-[#004f6b] cursor-pointer transition-colors flex items-center gap-1 group/email"
                                  onClick={() => handleCopyEmail(item.email)}
                                  title="Click to copy"
                                >
                                  {item.email}
                                  <svg className={`w-3 h-3 opacity-0 group-hover/email:opacity-100 transition-opacity ${copiedEmail === item.email ? 'text-green-500 opacity-100' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    {copiedEmail === item.email ? (
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    ) : (
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                                    )}
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <span className="px-2.5 py-1 bg-[#004f6b]/10 text-[#004f6b] rounded-lg text-xs font-medium border border-[#004f6b]/20">
                            {item.user_type}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-sm text-gray-600 font-medium whitespace-nowrap">
                            {new Date(item.created_at).toLocaleDateString('en-IN', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-2 text-xs font-medium text-gray-700">
                            <span>{item.campaign || 'N/A'}</span>
                            <span className="text-gray-300">/</span>
                            <span>{item.medium || 'N/A'}</span>
                            <span className="text-gray-300">/</span>
                            <span>{item.source || 'N/A'}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <div
                            className="cursor-pointer group/status relative"
                            onClick={() => changeStatus(item.id, item.status)}
                          >
                            <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border transition-all
                              ${item.status === 'active'
                                ? 'bg-green-50 text-green-700 border-green-200'
                                : 'bg-red-50 text-red-700 border-red-200'}`}>
                              {item.status.toUpperCase()}
                            </span>
                            <div className="absolute left-0 top-full mt-1 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/status:opacity-100 transition-opacity z-10 pointer-events-none whitespace-nowrap font-medium">
                              Click to {item.status === 'active' ? 'Deactivate' : 'Activate'}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="px-6 py-20 text-center">
                        <div className="flex flex-col items-center justify-center space-y-3">
                          <div className="bg-gray-50 p-4 rounded-full">
                            <svg className="w-12 h-12 text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                          </div>
                          <span className="text-gray-400 text-sm font-medium">No team members found.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        /* Add Member Form UI */
        <div className="max-w-4xl mx-auto py-8">
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="bg-gray-50 p-6 border-b border-gray-100 flex justify-between items-center">
              <div className="space-y-1">
                <h2 className="text-xl font-bold text-gray-900">Add New Team Member</h2>
                <p className="text-sm text-gray-500">Create a new organizational account for your team.</p>
              </div>
              <button
                onClick={closetab}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-200/50 rounded-lg transition-all"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={addNewmember} className="p-8 space-y-8">
              {/* Personal Info Group */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">First Name</label>
                  <input
                    type="text"
                    required
                    placeholder="Enter first name"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={teamfirstname}
                    onChange={(e) => setTeamfirstname(e.target.value)}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Last Name</label>
                  <input
                    type="text"
                    required
                    placeholder="Enter last name"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={teamlastname}
                    onChange={(e) => setTeamlastname(e.target.value)}
                  />
                </div>
                <div className="md:col-span-2 space-y-2">
                  <label className="text-xs font-medium text-gray-500 pl-1">Work Email</label>
                  <input
                    type="email"
                    required
                    placeholder="email@organization.com"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#004f6b]/20 focus:border-[#004f6b] outline-none transition-all"
                    value={teamemail}
                    onChange={(e) => setTeamemail(e.target.value.toLowerCase())}
                  />
                  {error && <p className="text-red-600 text-xs font-medium mt-1 pl-1">⚠️ {error}</p>}
                </div>
              </div>

              {/* Account Level Group */}
              <div className="space-y-2">
                <label className="text-xs font-medium text-gray-500 pl-1">Account Role</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {user.user_type === 'Admin' && (
                    <>
                      <button
                        type="button"
                        onClick={() => setTeamtype('SalesHead')}
                        className={`px-4 py-3 rounded-xl border text-sm font-semibold transition-all text-left flex items-center justify-between ${teamtype === 'SalesHead' ? 'bg-[#004f6b] text-white border-[#004f6b] shadow-lg shadow-[#004f6b]/20' : 'bg-gray-50 text-gray-600 border-gray-200 hover:border-gray-300'}`}
                      >
                        Sales Head
                        {teamtype === 'SalesHead' && <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>}
                      </button>
                    </>
                  )}
                  <button
                    type="button"
                    onClick={() => setTeamtype('SalesCounselor')}
                    className={`px-4 py-3 rounded-xl border text-sm font-semibold transition-all text-left flex items-center justify-between ${teamtype === 'SalesCounselor' ? 'bg-[#004f6b] text-white border-[#004f6b] shadow-lg shadow-[#004f6b]/20' : 'bg-gray-50 text-gray-600 border-gray-200 hover:border-gray-300'}`}
                  >
                    Sales Counselor
                    {teamtype === 'SalesCounselor' && <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>}
                  </button>
                </div>
              </div>

              {/* Marketing Context Group */}
              <div className="space-y-4 pt-4 border-t border-gray-100">
                <h4 className="text-base font-semibold text-gray-700">Marketing Attribution</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="space-y-2">
                    <label className="text-xs font-medium text-gray-400 pl-1">Source</label>
                    <input
                      type="text"
                      required
                      placeholder="e.g. Google"
                      className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:border-[#004f6b] outline-none transition-all text-sm"
                      value={source}
                      onChange={(e) => setSource(e.target.value)}
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-medium text-gray-400 pl-1">Campaign</label>
                    <input
                      type="text"
                      required
                      placeholder="e.g. Summer_2024"
                      className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:border-[#004f6b] outline-none transition-all text-sm"
                      value={campaign}
                      onChange={(e) => setCampaign(e.target.value)}
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-medium text-gray-400 pl-1">Medium</label>
                    <input
                      type="text"
                      required
                      placeholder="e.g. Social_Media"
                      className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:border-[#004f6b] outline-none transition-all text-sm"
                      value={medium}
                      onChange={(e) => setMedium(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {/* Form Actions */}
              <div className="flex flex-col-reverse md:flex-row gap-4 pt-6">
                <button
                  type="button"
                  onClick={closetab}
                  className="flex-1 px-6 py-3 border border-gray-200 text-gray-600 rounded-xl font-semibold hover:bg-gray-50 transition-all text-sm"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-[2] px-6 py-3 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold transition-all shadow-xl shadow-[#004f6b]/20 text-sm"
                >
                  Create Account
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Myteam;
